import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {ExtraFilteringOptions, LoadOptions} from '../../../shared/models/shared.model';
import {GridSetting, GridSettings, GridState, User} from '../../../shared';
import {Subject} from 'rxjs';
import {UserApi} from '../../../api';
import {FilterBuilderService} from '../../../service/filter-builder.service';
import {LoaderService} from '../../../core/loader/loader.service';
import {ProductBarcodeService} from '../../../api/product-barcode.service';
import {take, takeUntil} from 'rxjs/operators';
import CustomStore from 'devextreme/data/custom_store';
import {
	BarcodeMappingGridWithGlobalCompanyPrefixModel,
	ProductBarcodeAssignmentToMasterGridResultModel,
	ProductBarcodeMappingOption
} from '../../../shared/models/product-barcode.model';
import {DragulaService} from 'ng2-dragula';
import {MappingAction, MappingMode} from '../../../shared/enum/mapping-mode.enum';
import {NotificationType} from '../../../shared/enum/notification.enum';
import {NotificationService} from '../../../service/notification.service';
import {ProductMappingComponent} from '../product-mapping/product-mapping.component';
import {NgbActiveModal, NgbModal} from '@ng-bootstrap/ng-bootstrap';

@Component({
	selector: 'app-product-barcode',
	templateUrl: 'product-barcode.component.html'
})
export class ProductBarcodeComponent implements OnInit, OnDestroy {
	@ViewChild('productBarcodeMasterGrid', {static: false}) productBarcodeMasterGrid: any;
	@ViewChild('productBarcodeAssignmentToMasterGrid', {static: false}) productBarcodeAssignmentToMasterGrid: any;
	@ViewChild('productMasterWithSizeListGrid', {static: false}) productMasterWithSizeListGrid: any;

	public productBarcodeMasterDataSource = {};
	public productBarcodeAssignmentToMasterGridDataSource: ProductBarcodeAssignmentToMasterGridResultModel[] = [];
	public productMasterWithSizeListGridDataSource = {};
	public selectedMasterGridRow: any;
	public isCreateProduct: boolean;

	public extraFilteringOptions: ExtraFilteringOptions[] = [
		{ column: 'Active', value: false },
	];
	public productBarcodeMasterGridSelectedRowMap: any;
	public productMasterWithSizeListGridSelectedRowMap = [];
	public currentUser: User;

	public isLoadProductBarcodeMasterDataSource: boolean;
	public isLoadProductMasterWithSizeListGridSource: boolean;

	private _destroyed$ = new Subject();
	private isProductBarcodeMasterLoading = false;
	private isProductMasterWithSizeListGridLoading = false;

	private readonly mappingGridName: string = 'productBarcodeMaster';
	private readonly masterGridName: string = 'productMasterWithSizeListGrid';
	private readonly pageName: string = 'productBarcodeAssignmentMapping';
	private currentProductBarcodeMasterDataGridState: GridState;
	private currentProductMasterWithSizeListGridDataGridState: GridState;
	private productBarcodeMasterDataGridSettings: GridSettings;
	private productMasterWithSizeListGridDataGridSettings: GridSettings;
	private isProductBarcodeMasterDataGridSettingLoading = true;
	private isProductMasterWithSizeListGridDataGridSettingLoading = true;
	private productBarcodeMasterDataGridSetting: GridSetting = new GridSetting();
	private productMasterWithSizeListGridDataGridSetting: GridSetting = new GridSetting();
	private productBarcodeMasterCurrentPage: number;
	private productMasterWithSizeListGridCurrentPage: any;
	private isProductBarcodeAssignmentToMasterGridLoading: boolean;
	private isProductMasterDataLoading: boolean;

	barcodeHeaderDataSource: any;
	quantityMultiplierHeaderDataSource: any;
	productMasterIdHeaderDataSource: any;
	createdByUserFullNameSortableOrPrincipalNameHeaderDataSource: any;
	createdOnHeaderDataSource: any;
	modifiedByUserFullNameSortableOrPrincipalNameHeaderDataSource: any;
	modifiedOnHeaderDataSource: any;
	reviewedByUserFullNameSortableOrPrincipalNameHeaderDataSource: any;
	reviewedOnHeaderDataSource: any;
	mappingModeNameHeaderDataSource: any;
	brandNameHeaderDataSource: any;
	categoryNameHeaderDataSource: any;
	companyNameHeaderDataSource: any;
	masterBrandNameHeaderDataSource: any;
	productNameHeaderDataSource: any;
	subBrandNameHeaderDataSource: any;
	subcategoryFormNameHeaderDataSource: any;
	subcategoryFunctionNameHeaderDataSource: any;
	private isMoveToNextRow: boolean;
	private productMappingSelectedRowIndex: number;
	private productBarcodeMappingSelectedRowIndex: any;

	constructor(
		private productBarcodeService: ProductBarcodeService,
		private userService: UserApi,
		private filterBuilder: FilterBuilderService,
		private loaderService: LoaderService,
		public dragulaService: DragulaService,
		private notificationService: NotificationService,
		private modalService: NgbModal,
		public activeModal: NgbActiveModal,
	) {
		dragulaService.createGroup('HANDLES3', {
			moves: (el, container, handle) => {
				return handle.className === 'fa fa-arrows';
			}
		});
	}

	ngOnInit() {
		this.loaderService.show();
		this.currentUser = this.userService.logonUser;
		if (!this.currentUser) {
			return;
		}

		this.productBarcodeMasterDataGridSettings = {
			PageName: this.pageName,
			GridName: this.mappingGridName,
			OwnedByUserId: this.currentUser.UserId
		};

		this.userService.getGridSettings(this.productBarcodeMasterDataGridSettings)
			.pipe(take(1))
			.subscribe((settings) => {
				if (settings && settings.Settings) {
					if (typeof settings.Settings === 'string') {
						this.productBarcodeMasterDataGridSetting = JSON.parse(settings.Settings);
					} else {
						this.productBarcodeMasterDataGridSetting = settings.Settings;
					}
				} else {
					this.productBarcodeMasterDataGridSettings.Settings = JSON.stringify({autosave: true});
					this.updateGridSettings(this.productBarcodeMasterDataGridSettings);
				}
				this.loadProductBarcodeMasterDataGridState();
		});

		this.loadProductBarcodeMappingHeaderData();

		this.productMasterWithSizeListGridDataGridSettings = {
			PageName: this.pageName,
			GridName: this.masterGridName,
			OwnedByUserId: this.currentUser.UserId
		};

		this.userService.getGridSettings(this.productMasterWithSizeListGridDataGridSettings)
			.pipe(take(1))
			.subscribe((settings) => {
				if (settings && settings.Settings) {
					if (typeof settings.Settings === 'string') {
						this.productMasterWithSizeListGridDataGridSetting = JSON.parse(settings.Settings);
					} else {
						this.productMasterWithSizeListGridDataGridSetting = settings.Settings;
					}
				} else {
					this.productMasterWithSizeListGridDataGridSettings.Settings = JSON.stringify({autosave: true});
					this.updateGridSettings(this.productMasterWithSizeListGridDataGridSettings);
				}
				this.loadProductMasterWithSizeListGridDataGridState();
			});
}

	private updateGridSettings(gridSettings: GridSettings) {
		gridSettings.SavedOn = new Date();
		this.userService.setGridSettings(gridSettings).pipe(take(1)).subscribe();
	}

	private updateGridState(gridState: GridState) {
		gridState.SavedOn = new Date();
		this.userService.setGridState(gridState).pipe(take(1)).subscribe();
	}

	onRowExpanding(e: any) {
		e.component.collapseAll(-1);
	}

	onRowExpanded(e: any) {
		e.component.selectRows([e.key]);
	}

	private loadProductMasterWithSizeListGridDataGridState() {
		this.userService.getGridState(this.productMasterWithSizeListGridDataGridSettings)
			.pipe(takeUntil(this._destroyed$))
			.subscribe((state) => {
				if (state) {
					this.currentProductMasterWithSizeListGridDataGridState = state;
				} else {
					this.currentProductMasterWithSizeListGridDataGridState = {
						PageName: this.pageName,
						GridName: this.masterGridName,
						OwnedByUserId: this.currentUser.UserId,
						State: null
					};
				}
				this.loadProductMasterWithSizeListGridDataGridSource();
			});
	}

	private loadProductBarcodeMasterDataGridState() {
		this.userService.getGridState(this.productBarcodeMasterDataGridSettings)
			.pipe(takeUntil(this._destroyed$))
			.subscribe((state) => {
				if (state) {
					this.currentProductBarcodeMasterDataGridState = state;
				} else {
					this.currentProductBarcodeMasterDataGridState = {
						PageName: this.pageName,
						GridName: this.mappingGridName,
						OwnedByUserId: this.currentUser.UserId,
						State: null
					};
				}
				this.loadProductBarcodeMasterDataSource();
			});
	}

	private loadProductBarcodeMasterDataSource() {
		this.isProductBarcodeMasterDataGridSettingLoading = false;
		this.productBarcodeMasterDataSource = new CustomStore({
			key: 'ProductBarcodeId',
			load: (loadOptions: any) => {
				this.isProductBarcodeMasterLoading = true;
				this.loaderService.show();
				const filter = this.formatFilterOperators(loadOptions.filter);
				const finalOptions: LoadOptions = loadOptions;
				finalOptions.filter = filter;

				return this.productBarcodeService.getProductBarcodeAssignmentGrid(finalOptions)
					.toPromise()
					.then((data: any) => {
						this.isProductBarcodeMasterLoading = false;
						this.loaderHandler();
						if (this.productBarcodeMasterGridSelectedRowMap) {
							const matchedData = data.data.find(item =>
								item.ProductBarcodeId === this.productBarcodeMasterGridSelectedRowMap.ProductBarcodeId);
							this.isMoveToNextRow = !!matchedData;
						}
						if (!data.data || data.data.length === 0) {
							this.productBarcodeAssignmentToMasterGridDataSource = [];
						}
						this.getProductBarcodeAssignmentToMasterGridData(data.data.ProductBarcodeId);
						return {
							data: data.data,
							totalCount: data.totalCount,
							summary: data.summary,
							groupCount: data.groupCount
						};
					})
					.catch(error => {
						this.isProductBarcodeMasterLoading = false;
						this.loaderHandler();
						throw new Error('Data Loading Error');
					});
			}
		});
		this.isLoadProductBarcodeMasterDataSource = true;
	}

	public getProductBarcodeAssignmentToMasterGridData(ProductBarcodeId: number) {
		if (!ProductBarcodeId) {
			return;
		}
		this.isProductBarcodeAssignmentToMasterGridLoading = true;
		this.loaderService.show();
		this.productBarcodeService.getGetProductBarcodeAssignmentToMasterGridResult(ProductBarcodeId)
			.pipe(take(1))
			.subscribe((data) => {
				this.isProductBarcodeAssignmentToMasterGridLoading = false;
				this.loaderHandler();
				this.productBarcodeAssignmentToMasterGridDataSource = data;
				this.productBarcodeAssignmentToMasterGrid.instance.option('dataSource', data);
			});
	}

	private loadProductMasterWithSizeListGridDataGridSource() {
		this.isProductMasterWithSizeListGridDataGridSettingLoading = false;
		this.productMasterWithSizeListGridDataSource = new CustomStore({
			key: 'ProductMasterId',
			load: (loadOptions: any) => {
				this.isProductMasterWithSizeListGridLoading = true;
				this.loaderService.show();
				const filter = this.formatFilterOperators(loadOptions.filter);
				const finalOptions: LoadOptions = loadOptions;
				finalOptions.filter = filter;

				return this.productBarcodeService.getProductMasterWithSizeListGrid(finalOptions)
					.toPromise()
					.then((data: any) => {
						this.isProductMasterWithSizeListGridLoading = false;
						this.loaderHandler();
						return {
							data: data.data,
							totalCount: data.totalCount,
							summary: data.summary,
							groupCount: data.groupCount
						};
					})
					.catch(error => {
						this.isProductMasterWithSizeListGridLoading = false;
						this.loaderHandler();
						throw new Error('Data Loading Error');
					});
			}
		});
		this.isLoadProductMasterWithSizeListGridSource = true;
	}

	onReady(e) {
		const grid = e.component;
		const selection = grid.getSelectedRowKeys();
		if (this.productBarcodeMasterGridSelectedRowMap) {
			const currentDataItems = this.productBarcodeMasterGrid.instance.getDataSource().items();
			const matchedData = currentDataItems.find(item =>
				item.ProductBarcodeId === this.productBarcodeMasterGridSelectedRowMap.ProductBarcodeId);
			if (!matchedData && this.productBarcodeMasterCurrentPage !== this.productBarcodeMasterGrid.instance.pageIndex()) {
				grid.selectRowsByIndexes([0]);
			}
		}
		if (selection.length === 0) {
			grid.selectRowsByIndexes([0]);
		} else {
			if (this.isMoveToNextRow && this.isNextRowAvailable) {
				this.moveToNextRow();
				this.isMoveToNextRow = false;
			} else {
				this.stayInRow();
			}
		}
	}

	private get isNextRowAvailable() {
		const productBarcodeMappingRowData = this.productBarcodeMasterGrid.instance.getRowElement(this.productMappingSelectedRowIndex + 1);
		if (productBarcodeMappingRowData) {
			return true;
		}

		return false;
	}

	private moveToNextRow() {
		this.setProductMappingSelectedRowIndex();
		this.productBarcodeMasterGrid.instance.selectRowsByIndexes([this.productBarcodeMappingSelectedRowIndex + 1]);
	}

	private stayInRow() {
		this.setProductMappingSelectedRowIndex();
		this.productBarcodeMasterGrid.instance.selectRowsByIndexes([this.productBarcodeMappingSelectedRowIndex]);
	}

	private setProductMappingSelectedRowIndex() {
		const selectedRowKey = this.productBarcodeMasterGridSelectedRowMap.ProductBarcodeId;
		const barcodeMappingSelectedRowIndex = this.productBarcodeMasterGrid.instance.getRowIndexByKey(selectedRowKey);
		this.productBarcodeMappingSelectedRowIndex = barcodeMappingSelectedRowIndex >= 0 ?
			barcodeMappingSelectedRowIndex : this.productBarcodeMappingSelectedRowIndex;
	}

	public loadProductBarcodeMasterState = () => {
		return this.currentProductBarcodeMasterDataGridState.State ? JSON.parse(this.currentProductBarcodeMasterDataGridState.State) : null;
	}

	public saveProductBarcodeMasterState = (state: any) => {
		if (this.productBarcodeMasterDataGridSetting) {
			let gridSetting: GridSetting;
			if (typeof this.productBarcodeMasterDataGridSetting === 'string') {
				gridSetting = JSON.parse(this.productBarcodeMasterDataGridSetting);
			} else {
				gridSetting = this.productBarcodeMasterDataGridSetting;
			}
			if (gridSetting.autosave) {
				this.currentProductBarcodeMasterDataGridState.State = JSON.stringify(state);
				this.updateGridState(this.currentProductBarcodeMasterDataGridState);
			}
		}
	}

	public loadProductMasterWithSizeListGridState = () => {
		return this.currentProductMasterWithSizeListGridDataGridState.State ? JSON.parse(this.currentProductMasterWithSizeListGridDataGridState.State) : null;
	}

	public saveProductMasterWithSizeListGridState = (state: any) => {
		if (this.productMasterWithSizeListGridDataGridSetting) {
			let gridSetting: GridSetting;
			if (typeof this.productMasterWithSizeListGridDataGridSetting === 'string') {
				gridSetting = JSON.parse(this.productMasterWithSizeListGridDataGridSetting);
			} else {
				gridSetting = this.productMasterWithSizeListGridDataGridSetting;
			}
			if (gridSetting.autosave) {
				this.currentProductMasterWithSizeListGridDataGridState.State = JSON.stringify(state);
				this.updateGridState(this.currentProductMasterWithSizeListGridDataGridState);
			}
		}
	}


	public productBarcodeMasterDataGridContextMenu(e) {
		if (e.target === 'content') {
			// e.items can be undefined
			if (!e.items) { e.items = []; }
			const rowData = e.row.data;

			// Add a custom menu item
			e.items.push(
				{
					text: 'Refresh',
					icon: 'refresh',
					onItemClick: () => {
						this.refreshProductBarcodeMasterDataGrid();
					}
				},
				{
					text: 'Lookup for Barcode',
					disabled: !rowData.Barcode,
					onItemClick: () => {
						this.lookupForBarcode(rowData.Barcode);
					}
				},
				{
					text: 'Fix Inconsistency',
					disabled: !rowData.InconsistentServiceAndProductMappingsExist,
					onItemClick: () => {
						this.fixInconsistency(rowData.Barcode);
					}
				},
				{
					text: 'Grid Settings',
					items: [
						{
							text: this.productBarcodeMasterDataGridSetting.autosave ? 'Disable autosave' : 'Enable autosave',
							onItemClick: () => {
								this.productBarcodeMasterDataGridSetting.autosave = !this.productBarcodeMasterDataGridSetting.autosave;
								this.productBarcodeMasterDataGridSettings.Settings = JSON.stringify(this.productBarcodeMasterDataGridSetting);
								this.updateGridSettings(this.productBarcodeMasterDataGridSettings);
							}
						},
						{
							text: 'Reset to Default',
							onItemClick: () => {
								this.userService.resetDataGridStateToDefault(this.mappingGridName, this.pageName, this.currentUser.UserId)
									.pipe(take(1))
									.subscribe(() => {
										this.refreshProductBarcodeMasterDataGrid();
									});
							}
						}
					]
				}
			);
		}
	}

	public productMasterWithSizeListGridContextMenu(e) {
		if (e.target === 'content') {
			// e.items can be undefined
			if (!e.items) { e.items = []; }

			// Add a custom menu item
			e.items.push(
				{
					text: 'Refresh',
					icon: 'refresh',
					onItemClick: () => {
						this.refreshProductMasterWithSizeListGrid();
					}
				},
				{
					text: 'Grid Settings',
					items: [
						{
							text: this.productMasterWithSizeListGridDataGridSetting.autosave ? 'Disable autosave' : 'Enable autosave',
							onItemClick: () => {
								this.productMasterWithSizeListGridDataGridSetting.autosave = !this.productMasterWithSizeListGridDataGridSetting.autosave;
								this.productMasterWithSizeListGridDataGridSettings.Settings = JSON.stringify(this.productMasterWithSizeListGridDataGridSetting);
								this.updateGridSettings(this.productMasterWithSizeListGridDataGridSettings);
							}
						},
						{
							text: 'Reset to Default',
							onItemClick: () => {
								this.userService.resetDataGridStateToDefault(this.masterGridName, this.pageName, this.currentUser.UserId)
									.pipe(take(1))
									.subscribe(() => {
										this.loadProductMasterWithSizeListGridDataGridState();
									});
							}
						}
					]
				}
			);
		}
	}

	private loaderHandler() {
		if (!this.isProductBarcodeMasterLoading &&
			!this.isProductMasterWithSizeListGridLoading &&
			!this.isProductBarcodeMasterDataGridSettingLoading &&
			!this.isProductMasterWithSizeListGridDataGridSettingLoading &&
		  !this.isProductBarcodeAssignmentToMasterGridLoading) {
			this.loaderService.hide();
		}
	}

	formatFilterOperators(rawFilter: any[]) {
		if (!rawFilter) {
			return null;
		}
		const filterData = this.filterBuilder.handleNotFilterFormatting(rawFilter);
		return this.filterBuilder.filterFormatting(filterData);
	}

	private refreshProductBarcodeMasterDataGrid() {
		this.productBarcodeMasterCurrentPage = this.productBarcodeMasterGrid.instance.pageIndex();
		this.productBarcodeMasterGrid.instance.refresh();
	}

	private refreshProductMasterWithSizeListGrid() {
		this.productMasterWithSizeListGridCurrentPage = this.productMasterWithSizeListGrid.instance.pageIndex();
		this.productMasterWithSizeListGrid.instance.refresh();
	}

	ngOnDestroy() {
		this.dragulaService.destroy('HANDLES3');
		this.loaderService.hide();
		this._destroyed$.next(null);
		this._destroyed$.complete();
	}

	selectionProductBarcodeMasterChangedHandler() {
		if (this.productBarcodeMasterGrid.instance.getSelectedRowsData()[0]) {
			this.getProductBarcodeAssignmentToMasterGridData(this.productBarcodeMasterGrid.instance.getSelectedRowsData()[0].ProductBarcodeId);
		}
	}

	selectionProductMasterWithSizeListChangedHandler() {
		if (this.productMasterWithSizeListGrid.instance.getSelectedRowsData()[0]) {
			this.productMasterWithSizeListGridSelectedRowMap = this.productMasterWithSizeListGrid.instance.getSelectedRowsData()[0];

		}
	}

	assign(ProductMasterId: any) {
		const mappingData: ProductBarcodeMappingOption = {};
		mappingData.ProductMasterId = ProductMasterId;
		mappingData.ProductBarcodeId = this.productBarcodeMasterGrid.instance.getSelectedRowsData()[0].ProductBarcodeId;
		mappingData.MappingModeId = MappingMode.Assigned;
		mappingData.ModifiedByUserId = this.currentUser.UserId;
		mappingData.ActionType = MappingAction.Assign;
		this.actionHandler(mappingData, 'Assigned');
	}

	fixMapping(ProductBarcodeId: any) {
		const mappingData: ProductBarcodeMappingOption = {};
		mappingData.ProductBarcodeId = ProductBarcodeId;
		mappingData.MappingModeId = MappingMode.FixMapping;
		mappingData.ModifiedByUserId = this.currentUser.UserId;
		mappingData.ActionType = MappingAction.FixMapping;
		this.actionHandler(mappingData, 'Mapping fixed');
	}

	review(ProductBarcodeId: any) {
		const mappingData: ProductBarcodeMappingOption = {};
		mappingData.ProductBarcodeId = ProductBarcodeId;
		mappingData.ModifiedByUserId = this.currentUser.UserId;
		mappingData.ActionType = MappingAction.Review;
		this.actionHandler(mappingData, 'Reviewed');
	}

	deactivate(ProductBarcodeId: any) {
		const mappingData: ProductBarcodeMappingOption = {};
		mappingData.ProductBarcodeId = ProductBarcodeId;
		mappingData.ModifiedByUserId = this.currentUser.UserId;
		mappingData.ActionType = MappingAction.Deactivate;
		this.actionHandler(mappingData, 'Deactivated');
	}

	reactivate(ProductBarcodeId: any) {
		const mappingData: ProductBarcodeMappingOption = {};
		mappingData.ProductBarcodeId = ProductBarcodeId;
		mappingData.ModifiedByUserId = this.currentUser.UserId;
		mappingData.ActionType = MappingAction.Reactivate;
		this.actionHandler(mappingData, 'Reactivated');
	}

	private actionHandler(mappingData: ProductBarcodeMappingOption, message: string) {
		this.loaderService.show();
		this.productBarcodeService.productBarcodeMappingAction(mappingData)
			.pipe(takeUntil(this._destroyed$))
			.subscribe((res) => {
				this.loaderHandler();
				if (res.State) {
					this.refreshProductBarcodeMasterDataGrid ();
					this.notificationService.show(`${message} successfully!`, NotificationType.Success);
				} else {
					this.notificationService.show('Something went wrong', NotificationType.Error);
				}
			});
	}

	productMappingSelectionChanged(selectedMasterGridRow) {
		this.selectedMasterGridRow = selectedMasterGridRow;
	}

	customizeProductBarcodeId(cellInfo) {
		return 'PBc_' + cellInfo.value;
	}

	customizeBarcodeMappingId(cellInfo) {
		return 'BcMp_' + cellInfo.value;
	}

	customizeProductMasterId(cellInfo) {
		return 'PMs_' + cellInfo.value;
	}

	createProduct() {
		this.isCreateProduct = true;
	}

	productMasterGridLoadingHandler(state: boolean) {
		this.isProductMasterDataLoading = state;
		this.loaderHandler();
	}

	private loadProductBarcodeMappingHeaderData() {
		this.barcodeHeaderDataSource = new CustomStore({
			load: (loadOptions: any) => {
				const columnName = 'Barcode';
				loadOptions.column = columnName;
				loadOptions.valueColumn = '';
				return this.getHeaderFiltersProductMapping(loadOptions);
			}
		});

		this.quantityMultiplierHeaderDataSource = new CustomStore({
			load: (loadOptions: any) => {
				const columnName = 'QuantityMultiplier';
				loadOptions.column = columnName;
				loadOptions.valueColumn = '';
				return this.getHeaderFiltersProductMapping(loadOptions);
			}
		});

		this.productMasterIdHeaderDataSource = new CustomStore({
			load: (loadOptions: any) => {
				const columnName = 'ProductMasterId';
				loadOptions.column = columnName;
				loadOptions.valueColumn = '';
				return this.getHeaderFiltersProductMapping(loadOptions);
			}
		});

		this.createdByUserFullNameSortableOrPrincipalNameHeaderDataSource = new CustomStore({
			load: (loadOptions: any) => {
				const columnName = 'CreatedByUserFullNameSortableOrPrincipalName';
				loadOptions.column = columnName;
				loadOptions.valueColumn = '';
				return this.getHeaderFiltersProductMapping(loadOptions);
			}
		});

		this.createdOnHeaderDataSource = new CustomStore({
			load: (loadOptions: any) => {
				const columnName = 'CreatedOn';
				loadOptions.column = columnName;
				loadOptions.valueColumn = '';
				return this.getHeaderFiltersProductMapping(loadOptions);
			}
		});

		this.modifiedByUserFullNameSortableOrPrincipalNameHeaderDataSource = new CustomStore({
			load: (loadOptions: any) => {
				const columnName = 'ModifiedByUserFullNameSortableOrPrincipalName';
				loadOptions.column = columnName;
				loadOptions.valueColumn = '';
				return this.getHeaderFiltersProductMapping(loadOptions);
			}
		});


		this.modifiedOnHeaderDataSource = new CustomStore({
			load: (loadOptions: any) => {
				const columnName = 'ModifiedOn';
				loadOptions.column = columnName;
				loadOptions.valueColumn = '';
				return this.getHeaderFiltersProductMapping(loadOptions);
			}
		});

		this.reviewedByUserFullNameSortableOrPrincipalNameHeaderDataSource = new CustomStore({
			load: (loadOptions: any) => {
				const columnName = 'ReviewedByUserFullNameSortableOrPrincipalName';
				loadOptions.column = columnName;
				loadOptions.valueColumn = '';
				return this.getHeaderFiltersProductMapping(loadOptions);
			}
		});

		this.reviewedOnHeaderDataSource = new CustomStore({
			load: (loadOptions: any) => {
				const columnName = 'ReviewedOn';
				loadOptions.column = columnName;
				loadOptions.valueColumn = '';
				return this.getHeaderFiltersProductMapping(loadOptions);
			}
		});

		this.brandNameHeaderDataSource = new CustomStore({
			load: (loadOptions: any) => {
				const columnName = 'BrandName';
				loadOptions.column = columnName;
				loadOptions.valueColumn = '';
				return this.getHeaderFiltersProductMapping(loadOptions);
			}
		});

		this.categoryNameHeaderDataSource = new CustomStore({
			load: (loadOptions: any) => {
				const columnName = 'CategoryName';
				loadOptions.column = columnName;
				loadOptions.valueColumn = '';
				return this.getHeaderFiltersProductMapping(loadOptions);
			}
		});

		this.companyNameHeaderDataSource = new CustomStore({
			load: (loadOptions: any) => {
				const columnName = 'CompanyName';
				loadOptions.column = columnName;
				loadOptions.valueColumn = '';
				return this.getHeaderFiltersProductMapping(loadOptions);
			}
		});

		this.masterBrandNameHeaderDataSource = new CustomStore({
			load: (loadOptions: any) => {
				const columnName = 'MasterBrandName';
				loadOptions.column = columnName;
				loadOptions.valueColumn = '';
				return this.getHeaderFiltersProductMapping(loadOptions);
			}
		});

		this.productNameHeaderDataSource = new CustomStore({
			load: (loadOptions: any) => {
				const columnName = 'ProductName';
				loadOptions.column = columnName;
				loadOptions.valueColumn = '';
				return this.getHeaderFiltersProductMapping(loadOptions);
			}
		});

		this.subBrandNameHeaderDataSource = new CustomStore({
			load: (loadOptions: any) => {
				const columnName = 'SubBrandName';
				loadOptions.column = columnName;
				loadOptions.valueColumn = '';
				return this.getHeaderFiltersProductMapping(loadOptions);
			}
		});

		this.subcategoryFormNameHeaderDataSource = new CustomStore({
			load: (loadOptions: any) => {
				const columnName = 'SubcategoryFormName';
				loadOptions.column = columnName;
				loadOptions.valueColumn = '';
				return this.getHeaderFiltersProductMapping(loadOptions);
			}
		});

		this.subcategoryFunctionNameHeaderDataSource = new CustomStore({
			load: (loadOptions: any) => {
				const columnName = 'SubcategoryFunctionName';
				loadOptions.column = columnName;
				loadOptions.valueColumn = '';
				return this.getHeaderFiltersProductMapping(loadOptions);
			}
		});
		this.mappingModeNameHeaderDataSource = [
			{
				text: 'New',
				value: 0
			},
			{
				text: 'Map',
				value: 1
			},
			{
				text: 'Save',
				value: 2
			},
			{
				text: 'Omit',
				value: 2
			}
		];
	}

	private async getHeaderFiltersProductMapping(loadOptions) {
		try {
			return await this.productBarcodeService.getProductBarcodeAssignmentGridHeaderFilters(loadOptions)
				.toPromise();
		} catch (error) {
			throw new Error ('Data Loading Error');
		}
	}

	reassign(ProductBarcodeId: number, ProductMasterId: number) {
		const mappingData: ProductBarcodeMappingOption = {};
		mappingData.ProductMasterId = ProductMasterId;
		mappingData.ProductBarcodeId = ProductBarcodeId;
		mappingData.ModifiedByUserId = this.currentUser.UserId;
		mappingData.ActionType = MappingAction.ReAssign;
		this.actionHandler(mappingData, 'Re assigned');
	}

	private lookupForBarcode(Barcode) {
		this.productBarcodeService.lookupBarcode(Barcode);
	}

	private fixInconsistency(cleanBarcode: any) {
		const modalRef = this.modalService.open(ProductMappingComponent, {
			size: 'xl',
			windowClass: 'inconsistency-product-mapping',
		});
		modalRef.componentInstance.cleanBarcode = cleanBarcode;
		modalRef.componentInstance.isModal = true;
		modalRef.result.then(result => {
			// onclose
			this.refreshProductBarcodeMasterDataGrid();
		}, (reason) => {
			// ondismiss
			this.refreshProductBarcodeMasterDataGrid();
		});
	}
}


